// Code generated by tygo. DO NOT EDIT.

//////////
// source: jira.go

export type CustomFieldName = string;
export const Institution: CustomFieldName = "Institution";
export const BusinessProcess: CustomFieldName = "Business Processes";
export const AssetAssociation: CustomFieldName = "Asset Association";
export const SecurityNeed: CustomFieldName = "Security need";
export const Price: CustomFieldName = "Price";
export const MethodID: CustomFieldName = "Method ID";
export const RuleID: CustomFieldName = "Rule ID";
export const ModuleID: CustomFieldName = "Module ID";
export const OldEits: CustomFieldName = "Old E-ITS";
export const Deleted: CustomFieldName = "Deleted from Cybsis";
export const ExportTime: CustomFieldName = "Export time";
export const Responsible: CustomFieldName = "Responsible";
export const Version: CustomFieldName = "Version";
export type CustomFieldType = string;
export const TextField: CustomFieldType = "com.atlassian.jira.plugin.system.customfieldtypes:textfield";
export const TextArea: CustomFieldType = "com.atlassian.jira.plugin.system.customfieldtypes:textarea";
export const FloatField: CustomFieldType = "com.atlassian.jira.plugin.system.customfieldtypes:float";
export const ReadOnlyField: CustomFieldType = "com.atlassian.jira.plugin.system.customfieldtypes:readonlyfield";
export type SearcherKey = string;
export const TextSearcher: SearcherKey = "com.atlassian.jira.plugin.system.customfieldtypes:textsearcher";
export const NumberSearcher: SearcherKey = "com.atlassian.jira.plugin.system.customfieldtypes:exactnumber";
export type ResponseText = string;
export const TaskUnsuccessfulResponse: ResponseText = "Task unsuccessful";
export const AdminRightsAreMissingResponse: ResponseText = "You must have global administrator rights in order to modify projects.";
export const ConfigurationMissingResponse: ResponseText = "Email and API token are required";
export const NoDomainConfigForInstanceResponse: ResponseText = "Could not find a domain configuration for instance";
export const NoIDsCouldBeExportedResponse: ResponseText = "None of the methods have a domain configuration for exporting";
export const RuleExportFailed: ResponseText = "Rule exporting failed";
export const ModuleExportFailed: ResponseText = "Module exporting failed";
export const IssueCreationError: ResponseText = "There was an error with issue creation";
export type Status = number /* int */;
export const NotInitialized: Status = 0;
export const AdminRightsAreMissing: Status = 1;
export const ConfigurationMissing: Status = 2;
export const NoDomainConfigForInstance: Status = 3;
export const TaskUnsuccessful: Status = 4;
export const ProjectInitialized: Status = 5;
export const InitializingInProgress: Status = 6;
export const ImportInProgress: Status = 7;
export const ImportCompleted: Status = 8;
export const ExportCompleted: Status = 9;
export const ExportInProgress: Status = 10;
export const DeleteInProgress: Status = 11;
export const DeleteCompleted: Status = 12;
export const ConfirmDelete: Status = 13;
export const NoIDsCouldBeExported: Status = 14;
export const RefreshNeeded: Status = 15;
export type Action = number /* int */;
export const StartExport: Action = 0;
export const StartDelete: Action = 1;
export const StartSync: Action = 2;
export const StartImport: Action = 3;
